const copyWrapperCls = "futc19difii";
const copyLabelCls = "futc12qqu96";

export { copyLabelCls, copyWrapperCls };
import "./copy-link.styles.linaria.module.css";
//# sourceMappingURL=copy-link.styles.js.map
